import './App.css';
import { HashRouter, Routes, Route } from 'react-router-dom';

import Home from './pages/Home';
import HEC from './pages/HEC';
import Facilities from './pages/Facilities';
import MessMenu from './pages/MessMenu';

import Navbar2 from './components/Navbar2';
import AppFooter from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

function App() {
  return (
    <div className="App">
    <HashRouter>
      <ScrollToTop />
      <Navbar2 />

      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route exact path="/hec" element={<HEC />} />
        <Route exact path="/facilities" element={<Facilities />} />
        <Route exact path="/mess-menu" element={<MessMenu />} />
      </Routes>

      <AppFooter />
    </HashRouter>
    </div>
  );
}

export default App;